const ZWJ = '‍';
const VS16 = /️/g;

/**
 * Twemoji file name (without extension) for an emoji sequence, using the standard Twemoji rule:
 * strip U+FE0F (variation selector-16) unless the sequence contains a ZWJ (U+200D); then join the
 * lower-case hex code points with "-". `"❤️"` → `"2764"`, `"🧑‍⚖️"` → `"1f9d1-200d-2696-fe0f"`.
 */
export function twemojiName(emoji: string): string {
  const raw = emoji.trim();
  const seq = raw.includes(ZWJ) ? raw : raw.replace(VS16, '');
  const points: string[] = [];
  for (const ch of seq) points.push((ch.codePointAt(0) ?? 0).toString(16));
  return points.join('-');
}

/** Public URL of the bundled Twemoji SVG (copied to `public/emoji/` by `scripts/copy-emoji.mjs`). */
export function twemojiUrl(emoji: string): string {
  return `/emoji/${twemojiName(emoji)}.svg`;
}
